// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_WISHLIST_STROLLER = "ulo\u017eenie ko\u010d\u00edka";
export const STROLLER_STROLLER_WAS_SAVED_A = "Ko\u010d\u00edk bol";
export const STROLLER_STROLLER_WAS_SAVED_B = "ulo\u017een\u00fd";
